<template>
  <section
    ref="dialogElement"
    class="zoom"
    :class="mode"
    v-bind="props"
    @click="handleClick"
  >
    <span v-if="isLoading">Loading</span>
    <img v-else :src="src" />
  </section>
</template>
<script lang="ts" setup>
import { onClickOutside } from '@vueuse/core';
interface Props {
  src: string;
}
const props = defineProps({
  src: null
});
const useDialog = useDialogStore();
const ratio = ref(16 / 9);
const img = new Image();
const isLoading = ref(true);
const dialog = useDialogStore();
const dialogElement = ref(null);
const loadImage = async () => {
  const promise = new Promise<void>((resolve, reject) => {
    img.onload = () => {
      isLoading.value = false;
      ratio.value = img.width / img.height;
      resolve();
    };
    img.onerror = (e) => {
      reject(e);
    };
    img.src = props.src;
    // img.src =
    //   'https://www.theartcycle.fr/blog/assets/images/the-art-cycle-lart-du-portrait-dame-couronnee-tombeau-de-menna-441x599.jpg';
  });
  return promise;
};
const mode = computed<'landscape' | 'portrait'>(() => {
  const viewportRatio = dialog.viewport.width / dialog.viewport.height;
  return ratio.value < viewportRatio ? 'portrait' : 'landscape';
});

// const
onClickOutside(dialogElement, () => {
  useDialog.close();
});

const handleClick = () => useDialog.close();
await loadImage();
</script>
<style lang="scss" scoped>
.zoom {
  display: flex;
  align-items: center;
  align-self: center;
  justify-content: center;
  overflow: hidden;
  object-fit: contain;
  &:hover {
    cursor: zoom-out;
  }
  @include mobile {
    padding: 2rem;
  }
  img {
    @include stroke('n', 'n');

    max-height: 100%;
    border: 0;
    box-shadow: rgb(0 0 0 / 16%) 0 10px 36px 0, rgb(0 0 0 / 6%) 0 0 0 1px;
    object-fit: contain;
  }

  &.portrait {
    height: 100%;
    img {
      width: auto;
      height: 100%;
      max-height: 100%;
    }
  }
}
</style>
